<template lang="html">
  <div class="information-layout">
    <InformationBreadcrumb />
    <div class="forms-padding">
      <b-row class="row-eq-height">
        <b-col col lg="3" md="3" sm="12" cols="12" class="profile-menu-card">
            <profileMenu />
        </b-col>
        <b-col col lg="9" md="9" sm="12" cols="12" class="forms-quoation-card mb-100">
          <InformationForm />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import InformationBreadcrumb from "../components/Information/InformationBreadcrumb.vue";
import profileMenu from "../components/Profile/profileMenu.vue";
import InformationForm from "../components/Information/InformationForm.vue";

export default {
  name: "Information",
  components: {
    InformationBreadcrumb,
    profileMenu,
    InformationForm,
  },
  methods: {},
};
</script>
<style lang="css">
.information-layout {
  padding-top: 25vh !important;
}
@media only screen and (max-width: 1077px) {
 .profile-menu-card{
     padding: 0px!important;
  }
  .forms-quoation-card{
      padding: 0px!important;
  }
}
</style>